module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ui-paywall-Artboard-7@2x.568f84d7.png";